import React, { useState, useCallback } from "react";
import IconButton from "@mui/material/IconButton";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import WarningIcon from "@mui/icons-material/Warning";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import { makeStyles } from "@mui/styles";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import PropTypes from "prop-types";
// const useStyles = makeStyles((theme) => ({
//   snackbar: {
//     marginRight: "50px",
//     color: "white",
//   },
//   alert: {
//     color: "white",
//     display: "flex",
//     alignItems: "center",
//   },
//   copyContainer: {
//     display: "flex",
//     alignItems: "center",
//   },
//   copyText: {
//     marginLeft: "4px",
//   },
//   whiteIcon: {
//     color: "white",
//   },
// }));

const CommonSnackbar = ({ open, onClose, message, severity, copyText = "" }) => {
  const [isCopied, setIsCopied] = useState(false);
  const classes = { color: "red" };

  const handleCopyClick = useCallback(() => {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(copyText)
        .then(() => {
          setIsCopied(true);
        })
        .catch((err) => {
          console.error("Failed to copy text: ", err);
        });
    }
  }, [copyText]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    onClose(event, reason);
    setIsCopied(false);
  };


  const getIcon = () => {
    switch (severity) {
      case "error":
        return <ErrorIcon style={{ color: "white" }} />;
      case "warning":
        return <WarningIcon style={{ color: "white" }} />;
      case "info":
        return <InfoIcon style={{ color: "white" }} />;
      case "success":
        return <CheckCircleIcon style={{ color: "white" }} />;
      default:
        return null;
    }
  };

  const getBackgroundColor = () => {
    switch (severity) {
      case "error":
        return "#d32f2f";
      case "warning":
        return "#ffa000";
      case "info":
        return "#1976d2";
      case "success":
        return "#4caf50";
      default:
        return "inherit";
    }
  };

  return (
    <Snackbar
      open={open}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      // className={classes.snackbar}
      style={{
        marginRight: "50px",
        color: "white",
      }}
    >
      <Alert
        onClose={handleClose}
        severity={severity || "success"}
        // className={classes.alert}
        style={{
          backgroundColor: getBackgroundColor(), color: "white",
          display: "flex",
          alignItems: "center",
        }}
        icon={getIcon()}
        action={
          <>
            {copyText && (
              <div style={{
                display: "flex",
                alignItems: "center",
              }}>
                <div>{copyText}</div>
                <IconButton size="small" onClick={handleCopyClick} style={{ marginLeft: "4px" }} color="inherit">
                  <FileCopyIcon />
                </IconButton>
                {isCopied ? "Copied!" : "Copy"}
              </div>
            )}
            <IconButton size="small" onClick={handleClose} style={{ marginLeft: "4px" }} color="inherit">
              <CloseIcon />
            </IconButton>
          </>
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
CommonSnackbar.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  severity: PropTypes.oneOf(["error", "warning", "info", "success"]),
  copyText: PropTypes.string,
};
export default CommonSnackbar;
